var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.4.2.0 (NJsonSchema v10.1.11.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export var API_BASE_URL = new InjectionToken('API_BASE_URL');
var GeneralServiceProxy = /** @class */ (function () {
    function GeneralServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    GeneralServiceProxy.prototype.getAllReligion = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/General/GetAllReligion";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllReligion(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllReligion(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    GeneralServiceProxy.prototype.processGetAllReligion = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_1 = resultData200; _i < resultData200_1.length; _i++) {
                        var item = resultData200_1[_i];
                        result200.push(DropDownDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    GeneralServiceProxy.prototype.getAllOccupations = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/General/GetAllOccupations";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllOccupations(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllOccupations(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    GeneralServiceProxy.prototype.processGetAllOccupations = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_2 = resultData200; _i < resultData200_2.length; _i++) {
                        var item = resultData200_2[_i];
                        result200.push(DropDownDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    GeneralServiceProxy.prototype.getAllBanks = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/General/GetAllBanks";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllBanks(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllBanks(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    GeneralServiceProxy.prototype.processGetAllBanks = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_3 = resultData200; _i < resultData200_3.length; _i++) {
                        var item = resultData200_3[_i];
                        result200.push(DropDownDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    GeneralServiceProxy.prototype.getAllCities = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/General/GetAllCities";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllCities(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllCities(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    GeneralServiceProxy.prototype.processGetAllCities = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_4 = resultData200; _i < resultData200_4.length; _i++) {
                        var item = resultData200_4[_i];
                        result200.push(DropDownDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    GeneralServiceProxy.prototype.getAllCountries = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/General/GetAllCountries";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllCountries(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllCountries(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    GeneralServiceProxy.prototype.processGetAllCountries = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_5 = resultData200; _i < resultData200_5.length; _i++) {
                        var item = resultData200_5[_i];
                        result200.push(DropDownDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    GeneralServiceProxy.prototype.getAllDegrees = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/General/GetAllDegrees";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllDegrees(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllDegrees(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    GeneralServiceProxy.prototype.processGetAllDegrees = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_6 = resultData200; _i < resultData200_6.length; _i++) {
                        var item = resultData200_6[_i];
                        result200.push(DropDownDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    GeneralServiceProxy.prototype.getAllDepartments = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/General/GetAllDepartments";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllDepartments(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllDepartments(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    GeneralServiceProxy.prototype.processGetAllDepartments = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_7 = resultData200; _i < resultData200_7.length; _i++) {
                        var item = resultData200_7[_i];
                        result200.push(DropDownDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    GeneralServiceProxy.prototype.getAllCategoriesByDepartmentId = function (departmentId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/General/GetAllCategoriesByDepartmentId?";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllCategoriesByDepartmentId(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllCategoriesByDepartmentId(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    GeneralServiceProxy.prototype.processGetAllCategoriesByDepartmentId = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_8 = resultData200; _i < resultData200_8.length; _i++) {
                        var item = resultData200_8[_i];
                        result200.push(DropDownDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    GeneralServiceProxy.prototype.getAllSubCategoriesByCategoryId = function (categoryId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/General/GetAllSubCategoriesByCategoryId?";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllSubCategoriesByCategoryId(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllSubCategoriesByCategoryId(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    GeneralServiceProxy.prototype.processGetAllSubCategoriesByCategoryId = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_9 = resultData200; _i < resultData200_9.length; _i++) {
                        var item = resultData200_9[_i];
                        result200.push(DropDownDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    GeneralServiceProxy.prototype.getAllCharges = function (categoryId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/General/GetAllCharges?";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllCharges(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllCharges(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    GeneralServiceProxy.prototype.processGetAllCharges = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_10 = resultData200; _i < resultData200_10.length; _i++) {
                        var item = resultData200_10[_i];
                        result200.push(DropDownDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    GeneralServiceProxy.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GeneralServiceProxy_Factory() { return new GeneralServiceProxy(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(API_BASE_URL, 8)); }, token: GeneralServiceProxy, providedIn: "root" });
    return GeneralServiceProxy;
}());
export { GeneralServiceProxy };
var MenteeServiceProxy = /** @class */ (function () {
    function MenteeServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    MenteeServiceProxy.prototype.update = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Mentee/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MenteeServiceProxy.prototype.processUpdate = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    MenteeServiceProxy.prototype.getMenteeProfile = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Mentee/GetMenteeProfile";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMenteeProfile(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMenteeProfile(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MenteeServiceProxy.prototype.processGetMenteeProfile = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CreateOrUpdateMenteeDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    MenteeServiceProxy.prototype.getMenteesForView = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Mentee/GetMenteesForView";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMenteesForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMenteesForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MenteeServiceProxy.prototype.processGetMenteesForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_11 = resultData200; _i < resultData200_11.length; _i++) {
                        var item = resultData200_11[_i];
                        result200.push(MenteesViewDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    MenteeServiceProxy.prototype.getMenteesForViewById = function (menteeId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Mentee/GetMenteesForViewById?";
        if (menteeId === null)
            throw new Error("The parameter 'menteeId' cannot be null.");
        else if (menteeId !== undefined)
            url_ += "menteeId=" + encodeURIComponent("" + menteeId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMenteesForViewById(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMenteesForViewById(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MenteeServiceProxy.prototype.processGetMenteesForViewById = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = MenteesViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    MenteeServiceProxy.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MenteeServiceProxy_Factory() { return new MenteeServiceProxy(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(API_BASE_URL, 8)); }, token: MenteeServiceProxy, providedIn: "root" });
    return MenteeServiceProxy;
}());
export { MenteeServiceProxy };
var MentorServiceProxy = /** @class */ (function () {
    function MentorServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    MentorServiceProxy.prototype.updateMentor = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Mentor/UpdateMentor";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateMentor(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateMentor(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MentorServiceProxy.prototype.processUpdateMentor = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    MentorServiceProxy.prototype.getMentoreProfile = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Mentor/GetMentoreProfile";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMentoreProfile(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMentoreProfile(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MentorServiceProxy.prototype.processGetMentoreProfile = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CreateOrUpdateMentorDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    MentorServiceProxy.prototype.getMentoreProfileById = function (mentorId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Mentor/GetMentoreProfileById?";
        if (mentorId === null)
            throw new Error("The parameter 'mentorId' cannot be null.");
        else if (mentorId !== undefined)
            url_ += "mentorId=" + encodeURIComponent("" + mentorId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMentoreProfileById(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMentoreProfileById(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MentorServiceProxy.prototype.processGetMentoreProfileById = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = MentorDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    MentorServiceProxy.prototype.gellAllMentors = function (departmentId, categoryId, subCategory, countryid, city, profession, charges, filter) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Mentor/GetAllMentors?";
        if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (subCategory !== undefined)
            url_ += "subCategory=" + encodeURIComponent("" + subCategory) + "&";
        if (countryid !== undefined)
            url_ += "countryid=" + encodeURIComponent("" + countryid) + "&";
        if (city !== undefined)
            url_ += "city=" + encodeURIComponent("" + city) + "&";
        if (profession !== undefined)
            url_ += "profession=" + encodeURIComponent("" + profession) + "&";
        if (charges !== undefined)
            url_ += "charges=" + encodeURIComponent("" + charges) + "&";
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGellAllMentors(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGellAllMentors(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MentorServiceProxy.prototype.processGellAllMentors = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_12 = resultData200; _i < resultData200_12.length; _i++) {
                        var item = resultData200_12[_i];
                        result200.push(MentorViewDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    MentorServiceProxy.prototype.getAllMentorsCharages = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Mentor/GetAllMentorsCharages";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllMentorsCharages(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllMentorsCharages(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MentorServiceProxy.prototype.processGetAllMentorsCharages = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_13 = resultData200; _i < resultData200_13.length; _i++) {
                        var item = resultData200_13[_i];
                        result200.push(MentorCharageDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    MentorServiceProxy.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MentorServiceProxy_Factory() { return new MentorServiceProxy(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(API_BASE_URL, 8)); }, token: MentorServiceProxy, providedIn: "root" });
    return MentorServiceProxy;
}());
export { MentorServiceProxy };
var AccountServiceProxy = /** @class */ (function () {
    function AccountServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    AccountServiceProxy.prototype.logIn = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/Login";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processLogIn(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processLogIn(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processLogIn = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = LoginResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    AccountServiceProxy.prototype.signup = function (signUp) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/Signup";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(signUp);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSignup(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSignup(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processSignup = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = SignUpResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    AccountServiceProxy.prototype.signupWithLogin = function (signUp) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/SignupWithLogin";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(signUp);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSignupWithLogin(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSignupWithLogin(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processSignupWithLogin = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = LoginResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    AccountServiceProxy.prototype.isEmailExist = function (emailAddress) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/IsEmailExist?";
        if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processIsEmailExist(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processIsEmailExist(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processIsEmailExist = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    AccountServiceProxy.prototype.isMobilePhoneExist = function (mobileNo) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/IsMobilePhoneExist?";
        if (mobileNo !== undefined)
            url_ += "mobileNo=" + encodeURIComponent("" + mobileNo) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processIsMobilePhoneExist(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processIsMobilePhoneExist(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processIsMobilePhoneExist = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    AccountServiceProxy.prototype.logOut = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/Logout";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processLogOut(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processLogOut(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processLogOut = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    AccountServiceProxy.prototype.getUserProfilePicture = function (userId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/GetUserProfilePicture?";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUserProfilePicture(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUserProfilePicture(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processGetUserProfilePicture = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetProfilePictureOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    AccountServiceProxy.prototype.getProfilePictureById = function (profilePictureId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/GetProfilePictureById?";
        if (profilePictureId !== undefined)
            url_ += "profilePictureId=" + encodeURIComponent("" + profilePictureId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetProfilePictureById(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetProfilePictureById(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processGetProfilePictureById = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetProfilePictureOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    AccountServiceProxy.prototype.changePassword = function (oldPassword, newPassword, confirmNewPassword) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/ChangePassword?";
        if (oldPassword !== undefined)
            url_ += "oldPassword=" + encodeURIComponent("" + oldPassword) + "&";
        if (newPassword !== undefined)
            url_ += "newPassword=" + encodeURIComponent("" + newPassword) + "&";
        if (confirmNewPassword !== undefined)
            url_ += "confirmNewPassword=" + encodeURIComponent("" + confirmNewPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processChangePassword(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processChangePassword(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processChangePassword = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = LoginResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    AccountServiceProxy.prototype.forgotPassword = function (emailAddress) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/ForgotPassword?";
        if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processForgotPassword(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processForgotPassword(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processForgotPassword = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    AccountServiceProxy.prototype.resetPassword = function (userId, resetToken, newPassword, confirmNewPassword) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/ResetPassword?";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (resetToken !== undefined)
            url_ += "resetToken=" + encodeURIComponent("" + resetToken) + "&";
        if (newPassword !== undefined)
            url_ += "newPassword=" + encodeURIComponent("" + newPassword) + "&";
        if (confirmNewPassword !== undefined)
            url_ += "confirmNewPassword=" + encodeURIComponent("" + confirmNewPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processResetPassword(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processResetPassword(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processResetPassword = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Result.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    AccountServiceProxy.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AccountServiceProxy_Factory() { return new AccountServiceProxy(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(API_BASE_URL, 8)); }, token: AccountServiceProxy, providedIn: "root" });
    return AccountServiceProxy;
}());
export { AccountServiceProxy };
var AdminServiceProxy = /** @class */ (function () {
    function AdminServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    AdminServiceProxy.prototype.getAllAppointments = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Admin/GetAllAppointments";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllAppointments(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllAppointments(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AdminServiceProxy.prototype.processGetAllAppointments = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_14 = resultData200; _i < resultData200_14.length; _i++) {
                        var item = resultData200_14[_i];
                        result200.push(AppointmentDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    AdminServiceProxy.prototype.getAdminDashboadInfo = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Admin/GetAdminDashboadInfo";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAdminDashboadInfo(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAdminDashboadInfo(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AdminServiceProxy.prototype.processGetAdminDashboadInfo = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = AdminDashboardDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    AdminServiceProxy.prototype.approveAndRejectMentor = function (bit, mentorID) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Admin/ApproveAndRejectMentor?";
        if (bit === null)
            throw new Error("The parameter 'bit' cannot be null.");
        else if (bit !== undefined)
            url_ += "bit=" + encodeURIComponent("" + bit) + "&";
        if (mentorID === null)
            throw new Error("The parameter 'mentorID' cannot be null.");
        else if (mentorID !== undefined)
            url_ += "MentorID=" + encodeURIComponent("" + mentorID) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processApproveAndRejectMentor(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processApproveAndRejectMentor(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AdminServiceProxy.prototype.processApproveAndRejectMentor = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    AdminServiceProxy.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AdminServiceProxy_Factory() { return new AdminServiceProxy(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(API_BASE_URL, 8)); }, token: AdminServiceProxy, providedIn: "root" });
    return AdminServiceProxy;
}());
export { AdminServiceProxy };
var AppointmentServiceProxy = /** @class */ (function () {
    function AppointmentServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    AppointmentServiceProxy.prototype.createAppointment = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Appointment/CreateAppointment";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateAppointment(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateAppointment(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AppointmentServiceProxy.prototype.processCreateAppointment = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CreatePaymentDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    AppointmentServiceProxy.prototype.getAllAppointmentsByMentee = function (menteeId, isCompleted) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Appointment/GetAllAppointmentsByMentee?";
        if (menteeId === null)
            throw new Error("The parameter 'menteeId' cannot be null.");
        else if (menteeId !== undefined)
            url_ += "menteeId=" + encodeURIComponent("" + menteeId) + "&";
        if (isCompleted === null)
            throw new Error("The parameter 'isCompleted' cannot be null.");
        else if (isCompleted !== undefined)
            url_ += "isCompleted=" + encodeURIComponent("" + isCompleted) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllAppointmentsByMentee(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllAppointmentsByMentee(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AppointmentServiceProxy.prototype.processGetAllAppointmentsByMentee = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_15 = resultData200; _i < resultData200_15.length; _i++) {
                        var item = resultData200_15[_i];
                        result200.push(AppointmentDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    AppointmentServiceProxy.prototype.getAllAppointmentsByMentor = function (mentorId, isCompleted, isToday) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Appointment/GetAllAppointmentsByMentor?";
        if (mentorId === null)
            throw new Error("The parameter 'mentorId' cannot be null.");
        else if (mentorId !== undefined)
            url_ += "mentorId=" + encodeURIComponent("" + mentorId) + "&";
        if (isCompleted === null)
            throw new Error("The parameter 'isCompleted' cannot be null.");
        else if (isCompleted !== undefined)
            url_ += "isCompleted=" + encodeURIComponent("" + isCompleted) + "&";
        if (isToday === null)
            throw new Error("The parameter 'isToday' cannot be null.");
        else if (isToday !== undefined)
            url_ += "isToday=" + encodeURIComponent("" + isToday) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllAppointmentsByMentor(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllAppointmentsByMentor(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AppointmentServiceProxy.prototype.processGetAllAppointmentsByMentor = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_16 = resultData200; _i < resultData200_16.length; _i++) {
                        var item = resultData200_16[_i];
                        result200.push(AppointmentDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    AppointmentServiceProxy.prototype.getAppointmentsForView = function (appointmentId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Appointment/GetAppointmentsForView?";
        if (appointmentId === null)
            throw new Error("The parameter 'appointmentId' cannot be null.");
        else if (appointmentId !== undefined)
            url_ += "AppointmentId=" + encodeURIComponent("" + appointmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAppointmentsForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAppointmentsForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AppointmentServiceProxy.prototype.processGetAppointmentsForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = AppointmentForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    AppointmentServiceProxy.prototype.appointmentStatusChange = function (appintmentID, status) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Appointment/AppointmentStatusChange?";
        if (appintmentID === null)
            throw new Error("The parameter 'appintmentID' cannot be null.");
        else if (appintmentID !== undefined)
            url_ += "AppintmentID=" + encodeURIComponent("" + appintmentID) + "&";
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processAppointmentStatusChange(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processAppointmentStatusChange(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AppointmentServiceProxy.prototype.processAppointmentStatusChange = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    AppointmentServiceProxy.prototype.getAppointmentViewForInvoiceByID = function (appointmentId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Appointment/GetAppointmentViewForInvoiceByID?";
        if (appointmentId === null)
            throw new Error("The parameter 'appointmentId' cannot be null.");
        else if (appointmentId !== undefined)
            url_ += "AppointmentId=" + encodeURIComponent("" + appointmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAppointmentViewForInvoiceByID(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAppointmentViewForInvoiceByID(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AppointmentServiceProxy.prototype.processGetAppointmentViewForInvoiceByID = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = AppointmentForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    AppointmentServiceProxy.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AppointmentServiceProxy_Factory() { return new AppointmentServiceProxy(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(API_BASE_URL, 8)); }, token: AppointmentServiceProxy, providedIn: "root" });
    return AppointmentServiceProxy;
}());
export { AppointmentServiceProxy };
var CategoryServiceProxy = /** @class */ (function () {
    function CategoryServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    CategoryServiceProxy.prototype.getAllCategories = function (pageNumber, pageSize) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Category/GetAllCategories?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllCategories(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllCategories(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CategoryServiceProxy.prototype.processGetAllCategories = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_17 = resultData200; _i < resultData200_17.length; _i++) {
                        var item = resultData200_17[_i];
                        result200.push(CategoryDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    CategoryServiceProxy.prototype.getCategoryForEdit = function (categoryID) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Category/GetCategoryForEdit?";
        if (categoryID === null)
            throw new Error("The parameter 'categoryID' cannot be null.");
        else if (categoryID !== undefined)
            url_ += "categoryID=" + encodeURIComponent("" + categoryID) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCategoryForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCategoryForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CategoryServiceProxy.prototype.processGetCategoryForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CatgoryDtOForEdit.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    CategoryServiceProxy.prototype.deleteCategory = function (categoryID) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Category/DeleteCategory?";
        if (categoryID === null)
            throw new Error("The parameter 'categoryID' cannot be null.");
        else if (categoryID !== undefined)
            url_ += "categoryID=" + encodeURIComponent("" + categoryID) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteCategory(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteCategory(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CategoryServiceProxy.prototype.processDeleteCategory = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    CategoryServiceProxy.prototype.upsertCategory = function (id, name, departmentId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Category/UpsertCategory?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpsertCategory(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpsertCategory(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CategoryServiceProxy.prototype.processUpsertCategory = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    CategoryServiceProxy.prototype.getAllSubCategories = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Category/GetAllSubCategories";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllSubCategories(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllSubCategories(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CategoryServiceProxy.prototype.processGetAllSubCategories = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_18 = resultData200; _i < resultData200_18.length; _i++) {
                        var item = resultData200_18[_i];
                        result200.push(SubCategoryForViewDtocs.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    CategoryServiceProxy.prototype.upsertSubCategory = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Category/UpsertSubCategory";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpsertSubCategory(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpsertSubCategory(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CategoryServiceProxy.prototype.processUpsertSubCategory = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    CategoryServiceProxy.prototype.deleteSubCategory = function (subcategoryID) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Category/DeleteSubCategory?";
        if (subcategoryID === null)
            throw new Error("The parameter 'subcategoryID' cannot be null.");
        else if (subcategoryID !== undefined)
            url_ += "subcategoryID=" + encodeURIComponent("" + subcategoryID) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteSubCategory(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteSubCategory(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CategoryServiceProxy.prototype.processDeleteSubCategory = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    CategoryServiceProxy.prototype.getSubCategoryForEdit = function (subcategoryID) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Category/GetSubCategoryForEdit?";
        if (subcategoryID === null)
            throw new Error("The parameter 'subcategoryID' cannot be null.");
        else if (subcategoryID !== undefined)
            url_ += "subcategoryID=" + encodeURIComponent("" + subcategoryID) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetSubCategoryForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetSubCategoryForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CategoryServiceProxy.prototype.processGetSubCategoryForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = SubCategoryForEditDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    CategoryServiceProxy.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CategoryServiceProxy_Factory() { return new CategoryServiceProxy(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(API_BASE_URL, 8)); }, token: CategoryServiceProxy, providedIn: "root" });
    return CategoryServiceProxy;
}());
export { CategoryServiceProxy };
var DashboardServiceProxy = /** @class */ (function () {
    function DashboardServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    DashboardServiceProxy.prototype.getMentorDashboard = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Dashboard/GetMentorDashboard";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMentorDashboard(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMentorDashboard(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DashboardServiceProxy.prototype.processGetMentorDashboard = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = DashboardViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    DashboardServiceProxy.prototype.getMenteeDashboard = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Dashboard/GetMenteeDashboard";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMenteeDashboard(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMenteeDashboard(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DashboardServiceProxy.prototype.processGetMenteeDashboard = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = DashboardViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    DashboardServiceProxy.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DashboardServiceProxy_Factory() { return new DashboardServiceProxy(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(API_BASE_URL, 8)); }, token: DashboardServiceProxy, providedIn: "root" });
    return DashboardServiceProxy;
}());
export { DashboardServiceProxy };
var DegreeServiceProxy = /** @class */ (function () {
    function DegreeServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    DegreeServiceProxy.prototype.createOrEditDegree = function (id, name) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Degree/CreateOrEditDegree?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrEditDegree(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrEditDegree(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DegreeServiceProxy.prototype.processCreateOrEditDegree = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    DegreeServiceProxy.prototype.deleteDegree = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Degree/DeleteDegree?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteDegree(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteDegree(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DegreeServiceProxy.prototype.processDeleteDegree = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    DegreeServiceProxy.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DegreeServiceProxy_Factory() { return new DegreeServiceProxy(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(API_BASE_URL, 8)); }, token: DegreeServiceProxy, providedIn: "root" });
    return DegreeServiceProxy;
}());
export { DegreeServiceProxy };
var DepartmentServiceProxy = /** @class */ (function () {
    function DepartmentServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    DepartmentServiceProxy.prototype.upsertDepartment = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Department/UpsertDepartment";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpsertDepartment(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpsertDepartment(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DepartmentServiceProxy.prototype.processUpsertDepartment = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CreateOrEditDepartment.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    DepartmentServiceProxy.prototype.deleteDepartment = function (departmentId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Department/DeleteDepartment?";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteDepartment(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteDepartment(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DepartmentServiceProxy.prototype.processDeleteDepartment = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    DepartmentServiceProxy.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DepartmentServiceProxy_Factory() { return new DepartmentServiceProxy(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(API_BASE_URL, 8)); }, token: DepartmentServiceProxy, providedIn: "root" });
    return DepartmentServiceProxy;
}());
export { DepartmentServiceProxy };
var OccuptionServiceProxy = /** @class */ (function () {
    function OccuptionServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    OccuptionServiceProxy.prototype.createOrEditOccuption = function (id, name) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Occuption/CreateOrEditOccuption?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrEditOccuption(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrEditOccuption(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OccuptionServiceProxy.prototype.processCreateOrEditOccuption = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    OccuptionServiceProxy.prototype.deleteOccuption = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Occuption/DeleteOccuption?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteOccuption(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteOccuption(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OccuptionServiceProxy.prototype.processDeleteOccuption = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    OccuptionServiceProxy.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function OccuptionServiceProxy_Factory() { return new OccuptionServiceProxy(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(API_BASE_URL, 8)); }, token: OccuptionServiceProxy, providedIn: "root" });
    return OccuptionServiceProxy;
}());
export { OccuptionServiceProxy };
var PaymentServiceProxy = /** @class */ (function () {
    function PaymentServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    PaymentServiceProxy.prototype.getInvoice = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Payment/GetInvoice?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetInvoice(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetInvoice(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PaymentServiceProxy.prototype.processGetInvoice = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = InvoiceDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    PaymentServiceProxy.prototype.createPayment = function (createPaymentDto) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Payment/CreatePayment";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(createPaymentDto);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreatePayment(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreatePayment(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PaymentServiceProxy.prototype.processCreatePayment = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    PaymentServiceProxy.prototype.getActiveGateways = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Payment/GetActiveGateways";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetActiveGateways(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetActiveGateways(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PaymentServiceProxy.prototype.processGetActiveGateways = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_19 = resultData200; _i < resultData200_19.length; _i++) {
                        var item = resultData200_19[_i];
                        result200.push(PaymentGatewayModel.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    PaymentServiceProxy.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PaymentServiceProxy_Factory() { return new PaymentServiceProxy(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(API_BASE_URL, 8)); }, token: PaymentServiceProxy, providedIn: "root" });
    return PaymentServiceProxy;
}());
export { PaymentServiceProxy };
var QuestionServiceProxy = /** @class */ (function () {
    function QuestionServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    QuestionServiceProxy.prototype.create = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Question/create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    QuestionServiceProxy.prototype.processCreate = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    QuestionServiceProxy.prototype.update = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Question/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    QuestionServiceProxy.prototype.processUpdate = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    QuestionServiceProxy.prototype.selectMentor = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Question/selectmentor";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSelectMentor(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSelectMentor(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    QuestionServiceProxy.prototype.processSelectMentor = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = QuestionDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    QuestionServiceProxy.prototype.createQuestionResponce = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Question/CreateQuestionResponce";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateQuestionResponce(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateQuestionResponce(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    QuestionServiceProxy.prototype.processCreateQuestionResponce = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = QuestionResponceForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    QuestionServiceProxy.prototype.updateQuestionRating = function (questionId, rating) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Question/UpdateQuestionRating?";
        if (questionId === null)
            throw new Error("The parameter 'questionId' cannot be null.");
        else if (questionId !== undefined)
            url_ += "questionId=" + encodeURIComponent("" + questionId) + "&";
        if (rating === null)
            throw new Error("The parameter 'rating' cannot be null.");
        else if (rating !== undefined)
            url_ += "rating=" + encodeURIComponent("" + rating) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateQuestionRating(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateQuestionRating(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    QuestionServiceProxy.prototype.processUpdateQuestionRating = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    QuestionServiceProxy.prototype.getDetailForPayment = function (questionId, mentorId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Question/GetDetailForPayment?";
        if (questionId === null)
            throw new Error("The parameter 'questionId' cannot be null.");
        else if (questionId !== undefined)
            url_ += "questionId=" + encodeURIComponent("" + questionId) + "&";
        if (mentorId === null)
            throw new Error("The parameter 'mentorId' cannot be null.");
        else if (mentorId !== undefined)
            url_ += "mentorId=" + encodeURIComponent("" + mentorId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDetailForPayment(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDetailForPayment(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    QuestionServiceProxy.prototype.processGetDetailForPayment = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = QuestionDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    QuestionServiceProxy.prototype.getAllQuestionsByMentee = function (menteeId, isAnswered) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Question/GetAllQuestionsByMentee?";
        if (menteeId === null)
            throw new Error("The parameter 'menteeId' cannot be null.");
        else if (menteeId !== undefined)
            url_ += "menteeId=" + encodeURIComponent("" + menteeId) + "&";
        if (isAnswered === null)
            throw new Error("The parameter 'isAnswered' cannot be null.");
        else if (isAnswered !== undefined)
            url_ += "isAnswered=" + encodeURIComponent("" + isAnswered) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllQuestionsByMentee(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllQuestionsByMentee(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    QuestionServiceProxy.prototype.processGetAllQuestionsByMentee = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_20 = resultData200; _i < resultData200_20.length; _i++) {
                        var item = resultData200_20[_i];
                        result200.push(QuestionForViewDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    QuestionServiceProxy.prototype.getAllQuestionsByMentor = function (mentorId, isAnswered) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Question/GetAllQuestionsByMentor?";
        if (mentorId === null)
            throw new Error("The parameter 'mentorId' cannot be null.");
        else if (mentorId !== undefined)
            url_ += "mentorId=" + encodeURIComponent("" + mentorId) + "&";
        if (isAnswered === null)
            throw new Error("The parameter 'isAnswered' cannot be null.");
        else if (isAnswered !== undefined)
            url_ += "isAnswered=" + encodeURIComponent("" + isAnswered) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllQuestionsByMentor(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllQuestionsByMentor(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    QuestionServiceProxy.prototype.processGetAllQuestionsByMentor = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_21 = resultData200; _i < resultData200_21.length; _i++) {
                        var item = resultData200_21[_i];
                        result200.push(QuestionForViewDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    QuestionServiceProxy.prototype.getQuestionDetailForView = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Question/GetQuestionDetailForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetQuestionDetailForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetQuestionDetailForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    QuestionServiceProxy.prototype.processGetQuestionDetailForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = QuestionForViewDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    QuestionServiceProxy.prototype.getQuestionDetailForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Question/GetQuestionDetailForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetQuestionDetailForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetQuestionDetailForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    QuestionServiceProxy.prototype.processGetQuestionDetailForEdit = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CreateOrEditQuestionDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    QuestionServiceProxy.prototype.getAllQuestionDetailForView = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Question/GetAllQuestionDetailForView";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllQuestionDetailForView(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllQuestionDetailForView(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    QuestionServiceProxy.prototype.processGetAllQuestionDetailForView = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_22 = resultData200; _i < resultData200_22.length; _i++) {
                        var item = resultData200_22[_i];
                        result200.push(QuestionViewDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    QuestionServiceProxy.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function QuestionServiceProxy_Factory() { return new QuestionServiceProxy(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(API_BASE_URL, 8)); }, token: QuestionServiceProxy, providedIn: "root" });
    return QuestionServiceProxy;
}());
export { QuestionServiceProxy };
var ReligionServiceProxy = /** @class */ (function () {
    function ReligionServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    ReligionServiceProxy.prototype.createOrUpdate = function (id, reliogionName) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Religion/CreateOrUpdate?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (reliogionName !== undefined)
            url_ += "reliogionName=" + encodeURIComponent("" + reliogionName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReligionServiceProxy.prototype.processCreateOrUpdate = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ReligionServiceProxy.prototype.deleteReligion = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Religion/DeleteReligion?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteReligion(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteReligion(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReligionServiceProxy.prototype.processDeleteReligion = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ReligionServiceProxy.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ReligionServiceProxy_Factory() { return new ReligionServiceProxy(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(API_BASE_URL, 8)); }, token: ReligionServiceProxy, providedIn: "root" });
    return ReligionServiceProxy;
}());
export { ReligionServiceProxy };
var SMSServiceProxy = /** @class */ (function () {
    function SMSServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    SMSServiceProxy.prototype.sendSMS = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/SMS/SendSMS?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendSMS(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendSMS(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SMSServiceProxy.prototype.processSendSMS = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    SMSServiceProxy.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SMSServiceProxy_Factory() { return new SMSServiceProxy(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(API_BASE_URL, 8)); }, token: SMSServiceProxy, providedIn: "root" });
    return SMSServiceProxy;
}());
export { SMSServiceProxy };
var TodoItemsServiceProxy = /** @class */ (function () {
    function TodoItemsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    TodoItemsServiceProxy.prototype.create = function (command) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TodoItems";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TodoItemsServiceProxy.prototype.processCreate = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    TodoItemsServiceProxy.prototype.update = function (id, command) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TodoItems/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TodoItemsServiceProxy.prototype.processUpdate = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob, status: status, headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    TodoItemsServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TodoItems/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TodoItemsServiceProxy.prototype.processDelete = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob, status: status, headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    TodoItemsServiceProxy.prototype.updateItemDetails = function (id, command) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TodoItems/UpdateItemDetails?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateItemDetails(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateItemDetails(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TodoItemsServiceProxy.prototype.processUpdateItemDetails = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob, status: status, headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    TodoItemsServiceProxy.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TodoItemsServiceProxy_Factory() { return new TodoItemsServiceProxy(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(API_BASE_URL, 8)); }, token: TodoItemsServiceProxy, providedIn: "root" });
    return TodoItemsServiceProxy;
}());
export { TodoItemsServiceProxy };
var TodoListsServiceProxy = /** @class */ (function () {
    function TodoListsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    TodoListsServiceProxy.prototype.get = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/TodoLists";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TodoListsServiceProxy.prototype.processGet = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = TodosVm.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    TodoListsServiceProxy.prototype.create = function (command) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TodoLists";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TodoListsServiceProxy.prototype.processCreate = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    TodoListsServiceProxy.prototype.get2 = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TodoLists/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet2(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet2(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TodoListsServiceProxy.prototype.processGet2 = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob, status: status, headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    TodoListsServiceProxy.prototype.update = function (id, command) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TodoLists/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(command);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TodoListsServiceProxy.prototype.processUpdate = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob, status: status, headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    TodoListsServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TodoLists/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TodoListsServiceProxy.prototype.processDelete = function (response) {
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob, status: status, headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    TodoListsServiceProxy.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TodoListsServiceProxy_Factory() { return new TodoListsServiceProxy(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(API_BASE_URL, 8)); }, token: TodoListsServiceProxy, providedIn: "root" });
    return TodoListsServiceProxy;
}());
export { TodoListsServiceProxy };
var WeatherForecastServiceProxy = /** @class */ (function () {
    function WeatherForecastServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    WeatherForecastServiceProxy.prototype.get = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/WeatherForecast";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WeatherForecastServiceProxy.prototype.processGet = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_23 = resultData200; _i < resultData200_23.length; _i++) {
                        var item = resultData200_23[_i];
                        result200.push(WeatherForecast.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    WeatherForecastServiceProxy.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function WeatherForecastServiceProxy_Factory() { return new WeatherForecastServiceProxy(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(API_BASE_URL, 8)); }, token: WeatherForecastServiceProxy, providedIn: "root" });
    return WeatherForecastServiceProxy;
}());
export { WeatherForecastServiceProxy };
var DropDownDto = /** @class */ (function () {
    function DropDownDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DropDownDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    };
    DropDownDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DropDownDto();
        result.init(data);
        return result;
    };
    DropDownDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    };
    return DropDownDto;
}());
export { DropDownDto };
var UpdateMenteeCommand = /** @class */ (function () {
    function UpdateMenteeCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateMenteeCommand.prototype.init = function (_data) {
        if (_data) {
            this.createOrUpdateMenteeDto = _data["createOrUpdateMenteeDto"] ? CreateOrUpdateMenteeDto.fromJS(_data["createOrUpdateMenteeDto"]) : undefined;
        }
    };
    UpdateMenteeCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateMenteeCommand();
        result.init(data);
        return result;
    };
    UpdateMenteeCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["createOrUpdateMenteeDto"] = this.createOrUpdateMenteeDto ? this.createOrUpdateMenteeDto.toJSON() : undefined;
        return data;
    };
    return UpdateMenteeCommand;
}());
export { UpdateMenteeCommand };
var CreateOrUpdateMenteeDto = /** @class */ (function () {
    function CreateOrUpdateMenteeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrUpdateMenteeDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.gender = _data["gender"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : undefined;
            this.address = _data["address"];
            this.countryId = _data["countryId"];
            this.cityId = _data["cityId"];
            this.city = _data["city"];
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.phoneNo = _data["phoneNo"];
        }
    };
    CreateOrUpdateMenteeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrUpdateMenteeDto();
        result.init(data);
        return result;
    };
    CreateOrUpdateMenteeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["gender"] = this.gender;
        data["dob"] = this.dob ? this.dob.toISOString() : undefined;
        data["address"] = this.address;
        data["countryId"] = this.countryId;
        data["cityId"] = this.cityId;
        data["city"] = this.city;
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["phoneNo"] = this.phoneNo;
        return data;
    };
    return CreateOrUpdateMenteeDto;
}());
export { CreateOrUpdateMenteeDto };
var MenteesViewDto = /** @class */ (function () {
    function MenteesViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MenteesViewDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.gender = _data["gender"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : undefined;
            this.address = _data["address"];
            this.countryName = _data["countryName"];
            this.city = _data["city"];
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.phoneNo = _data["phoneNo"];
            this.profileId = _data["profileId"];
            this.profileDate = _data["profileDate"];
            this.menteeUserInfoDto = _data["menteeUserInfoDto"] ? MenteeUserInfo.fromJS(_data["menteeUserInfoDto"]) : undefined;
        }
    };
    MenteesViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MenteesViewDto();
        result.init(data);
        return result;
    };
    MenteesViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["gender"] = this.gender;
        data["dob"] = this.dob ? this.dob.toISOString() : undefined;
        data["address"] = this.address;
        data["countryName"] = this.countryName;
        data["city"] = this.city;
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["phoneNo"] = this.phoneNo;
        data["profileId"] = this.profileId;
        data["profileDate"] = this.profileDate;
        data["menteeUserInfoDto"] = this.menteeUserInfoDto ? this.menteeUserInfoDto.toJSON() : undefined;
        return data;
    };
    return MenteesViewDto;
}());
export { MenteesViewDto };
var MenteeUserInfo = /** @class */ (function () {
    function MenteeUserInfo(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MenteeUserInfo.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            this.lockoutEnd = _data["lockoutEnd"] ? new Date(_data["lockoutEnd"].toString()) : undefined;
            this.twoFactorEnabled = _data["twoFactorEnabled"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.phoneNumber = _data["phoneNumber"];
            this.securityStamp = _data["securityStamp"];
            this.passwordHash = _data["passwordHash"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.normalizedEmail = _data["normalizedEmail"];
            this.email = _data["email"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.userName = _data["userName"];
        }
    };
    MenteeUserInfo.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MenteeUserInfo();
        result.init(data);
        return result;
    };
    MenteeUserInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : undefined;
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["phoneNumber"] = this.phoneNumber;
        data["securityStamp"] = this.securityStamp;
        data["passwordHash"] = this.passwordHash;
        data["emailConfirmed"] = this.emailConfirmed;
        data["normalizedEmail"] = this.normalizedEmail;
        data["email"] = this.email;
        data["normalizedUserName"] = this.normalizedUserName;
        data["userName"] = this.userName;
        return data;
    };
    return MenteeUserInfo;
}());
export { MenteeUserInfo };
var UpdateMentorCommand = /** @class */ (function () {
    function UpdateMentorCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateMentorCommand.prototype.init = function (_data) {
        if (_data) {
            this.createOrUpdateMentor = _data["createOrUpdateMentor"] ? CreateOrUpdateMentorDto.fromJS(_data["createOrUpdateMentor"]) : undefined;
        }
    };
    UpdateMentorCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateMentorCommand();
        result.init(data);
        return result;
    };
    UpdateMentorCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["createOrUpdateMentor"] = this.createOrUpdateMentor ? this.createOrUpdateMentor.toJSON() : undefined;
        return data;
    };
    return UpdateMentorCommand;
}());
export { UpdateMentorCommand };
var CreateOrUpdateMentorDto = /** @class */ (function () {
    function CreateOrUpdateMentorDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrUpdateMentorDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.fatherName = _data["fatherName"];
            this.gender = _data["gender"];
            this.religionId = _data["religionId"];
            this.occupationId = _data["occupationId"];
            this.countryId = _data["countryId"];
            this.cityId = _data["cityId"];
            this.city = _data["city"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : undefined;
            this.cnic = _data["cnic"];
            this.passport = _data["passport"];
            this.address = _data["address"];
            this.monthlyIncome = _data["monthlyIncome"];
            this.chargesPerAnswer = _data["chargesPerAnswer"];
            this.appointmentCharges = _data["appointmentCharges"];
            this.availableTimingFrom = _data["availableTimingFrom"];
            this.availableTimingTo = _data["availableTimingTo"];
            this.homeVisit = _data["homeVisit"];
            this.homeVisitCharges = _data["homeVisitCharges"];
            this.bankAccountTitle = _data["bankAccountTitle"];
            this.bankAccountNo = _data["bankAccountNo"];
            this.bankId = _data["bankId"];
            this.cardNo = _data["cardNo"];
            this.cardType = _data["cardType"];
            this.validTill = _data["validTill"] ? new Date(_data["validTill"].toString()) : undefined;
            this.userId = _data["userId"];
            this.averageRating = _data["averageRating"];
            this.isProve = _data["isProve"];
            if (Array.isArray(_data["mentorExperienceDtos"])) {
                this.mentorExperienceDtos = [];
                for (var _i = 0, _a = _data["mentorExperienceDtos"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.mentorExperienceDtos.push(MentorExperienceDto.fromJS(item));
                }
            }
            if (Array.isArray(_data["mentorEducationDtos"])) {
                this.mentorEducationDtos = [];
                for (var _b = 0, _c = _data["mentorEducationDtos"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.mentorEducationDtos.push(MentorEducationDto.fromJS(item));
                }
            }
            if (Array.isArray(_data["mentorSkillSetDtos"])) {
                this.mentorSkillSetDtos = [];
                for (var _d = 0, _e = _data["mentorSkillSetDtos"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.mentorSkillSetDtos.push(MentorSkillSetDto.fromJS(item));
                }
            }
        }
    };
    CreateOrUpdateMentorDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrUpdateMentorDto();
        result.init(data);
        return result;
    };
    CreateOrUpdateMentorDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["fatherName"] = this.fatherName;
        data["gender"] = this.gender;
        data["religionId"] = this.religionId;
        data["occupationId"] = this.occupationId;
        data["countryId"] = this.countryId;
        data["cityId"] = this.cityId;
        data["city"] = this.city;
        data["dob"] = this.dob ? this.dob.toISOString() : undefined;
        data["cnic"] = this.cnic;
        data["passport"] = this.passport;
        data["address"] = this.address;
        data["monthlyIncome"] = this.monthlyIncome;
        data["chargesPerAnswer"] = this.chargesPerAnswer;
        data["appointmentCharges"] = this.appointmentCharges;
        data["availableTimingFrom"] = this.availableTimingFrom;
        data["availableTimingTo"] = this.availableTimingTo;
        data["homeVisit"] = this.homeVisit;
        data["homeVisitCharges"] = this.homeVisitCharges;
        data["bankAccountTitle"] = this.bankAccountTitle;
        data["bankAccountNo"] = this.bankAccountNo;
        data["bankId"] = this.bankId;
        data["cardNo"] = this.cardNo;
        data["cardType"] = this.cardType;
        data["validTill"] = this.validTill ? this.validTill.toISOString() : undefined;
        data["userId"] = this.userId;
        data["averageRating"] = this.averageRating;
        data["isProve"] = this.isProve;
        if (Array.isArray(this.mentorExperienceDtos)) {
            data["mentorExperienceDtos"] = [];
            for (var _i = 0, _a = this.mentorExperienceDtos; _i < _a.length; _i++) {
                var item = _a[_i];
                data["mentorExperienceDtos"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.mentorEducationDtos)) {
            data["mentorEducationDtos"] = [];
            for (var _b = 0, _c = this.mentorEducationDtos; _b < _c.length; _b++) {
                var item = _c[_b];
                data["mentorEducationDtos"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.mentorSkillSetDtos)) {
            data["mentorSkillSetDtos"] = [];
            for (var _d = 0, _e = this.mentorSkillSetDtos; _d < _e.length; _d++) {
                var item = _e[_d];
                data["mentorSkillSetDtos"].push(item.toJSON());
            }
        }
        return data;
    };
    return CreateOrUpdateMentorDto;
}());
export { CreateOrUpdateMentorDto };
var MentorExperienceDto = /** @class */ (function () {
    function MentorExperienceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MentorExperienceDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.companyName = _data["companyName"];
            this.workFrom = _data["workFrom"] ? new Date(_data["workFrom"].toString()) : undefined;
            this.workTo = _data["workTo"] ? new Date(_data["workTo"].toString()) : undefined;
            this.isCurrentlyWorking = _data["isCurrentlyWorking"];
            this.experienceCertificateId = _data["experienceCertificateId"];
            this.certificateDescription = _data["certificateDescription"];
        }
    };
    MentorExperienceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MentorExperienceDto();
        result.init(data);
        return result;
    };
    MentorExperienceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyName"] = this.companyName;
        data["workFrom"] = this.workFrom ? this.workFrom.toISOString() : undefined;
        data["workTo"] = this.workTo ? this.workTo.toISOString() : undefined;
        data["isCurrentlyWorking"] = this.isCurrentlyWorking;
        data["experienceCertificateId"] = this.experienceCertificateId;
        data["certificateDescription"] = this.certificateDescription;
        return data;
    };
    return MentorExperienceDto;
}());
export { MentorExperienceDto };
var MentorEducationDto = /** @class */ (function () {
    function MentorEducationDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MentorEducationDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.degreeId = _data["degreeId"];
            this.yearCompleted = _data["yearCompleted"];
            this.degreeName = _data["degreeName"];
            this.subject = _data["subject"];
            this.institute = _data["institute"];
        }
    };
    MentorEducationDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MentorEducationDto();
        result.init(data);
        return result;
    };
    MentorEducationDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["degreeId"] = this.degreeId;
        data["yearCompleted"] = this.yearCompleted;
        data["degreeName"] = this.degreeName;
        data["subject"] = this.subject;
        data["institute"] = this.institute;
        return data;
    };
    return MentorEducationDto;
}());
export { MentorEducationDto };
var MentorSkillSetDto = /** @class */ (function () {
    function MentorSkillSetDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MentorSkillSetDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.mentorId = _data["mentorId"];
            this.departmentId = _data["departmentId"];
            this.departmentName = _data["departmentName"];
            this.categoryId = _data["categoryId"];
            this.categoryName = _data["categoryName"];
            this.subCategoryId = _data["subCategoryId"];
            this.subCategoryName = _data["subCategoryName"];
        }
    };
    MentorSkillSetDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MentorSkillSetDto();
        result.init(data);
        return result;
    };
    MentorSkillSetDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mentorId"] = this.mentorId;
        data["departmentId"] = this.departmentId;
        data["departmentName"] = this.departmentName;
        data["categoryId"] = this.categoryId;
        data["categoryName"] = this.categoryName;
        data["subCategoryId"] = this.subCategoryId;
        data["subCategoryName"] = this.subCategoryName;
        return data;
    };
    return MentorSkillSetDto;
}());
export { MentorSkillSetDto };
var MentorDto = /** @class */ (function () {
    function MentorDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MentorDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.fatherName = _data["fatherName"];
            this.fullName = _data["fullName"];
            this.gender = _data["gender"];
            this.religion = _data["religion"];
            this.profession = _data["profession"];
            this.countryName = _data["countryName"];
            this.city = _data["city"];
            this.age = _data["age"];
            this.address = _data["address"];
            this.chargesPerAnswer = _data["chargesPerAnswer"];
            this.appointmentCharges = _data["appointmentCharges"];
            this.availableTimingFrom = _data["availableTimingFrom"];
            this.availableTimingTo = _data["availableTimingTo"];
            this.homeVisit = _data["homeVisit"];
            this.homeVisitCharges = _data["homeVisitCharges"];
            this.averageRating = _data["averageRating"];
            this.userId = _data["userId"];
            this.isProfileCompleted = _data["isProfileCompleted"];
            this.profileCompletePercentage = _data["profileCompletePercentage"];
            this.isProve = _data["isProve"];
            this.userInfoDto = _data["userInfoDto"] ? MentorUserInfo.fromJS(_data["userInfoDto"]) : undefined;
            if (Array.isArray(_data["mentorExperienceDtos"])) {
                this.mentorExperienceDtos = [];
                for (var _i = 0, _a = _data["mentorExperienceDtos"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.mentorExperienceDtos.push(MentorExperienceDto.fromJS(item));
                }
            }
            if (Array.isArray(_data["mentorEducationDtos"])) {
                this.mentorEducationDtos = [];
                for (var _b = 0, _c = _data["mentorEducationDtos"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.mentorEducationDtos.push(MentorEducationDto.fromJS(item));
                }
            }
            if (Array.isArray(_data["mentorSkillSetDtos"])) {
                this.mentorSkillSetDtos = [];
                for (var _d = 0, _e = _data["mentorSkillSetDtos"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.mentorSkillSetDtos.push(MentorSkillSetDto.fromJS(item));
                }
            }
        }
    };
    MentorDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MentorDto();
        result.init(data);
        return result;
    };
    MentorDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["fatherName"] = this.fatherName;
        data["fullName"] = this.fullName;
        data["gender"] = this.gender;
        data["religion"] = this.religion;
        data["profession"] = this.profession;
        data["countryName"] = this.countryName;
        data["city"] = this.city;
        data["age"] = this.age;
        data["address"] = this.address;
        data["chargesPerAnswer"] = this.chargesPerAnswer;
        data["appointmentCharges"] = this.appointmentCharges;
        data["availableTimingFrom"] = this.availableTimingFrom;
        data["availableTimingTo"] = this.availableTimingTo;
        data["homeVisit"] = this.homeVisit;
        data["homeVisitCharges"] = this.homeVisitCharges;
        data["averageRating"] = this.averageRating;
        data["userId"] = this.userId;
        data["isProfileCompleted"] = this.isProfileCompleted;
        data["profileCompletePercentage"] = this.profileCompletePercentage;
        data["isProve"] = this.isProve;
        data["userInfoDto"] = this.userInfoDto ? this.userInfoDto.toJSON() : undefined;
        if (Array.isArray(this.mentorExperienceDtos)) {
            data["mentorExperienceDtos"] = [];
            for (var _i = 0, _a = this.mentorExperienceDtos; _i < _a.length; _i++) {
                var item = _a[_i];
                data["mentorExperienceDtos"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.mentorEducationDtos)) {
            data["mentorEducationDtos"] = [];
            for (var _b = 0, _c = this.mentorEducationDtos; _b < _c.length; _b++) {
                var item = _c[_b];
                data["mentorEducationDtos"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.mentorSkillSetDtos)) {
            data["mentorSkillSetDtos"] = [];
            for (var _d = 0, _e = this.mentorSkillSetDtos; _d < _e.length; _d++) {
                var item = _e[_d];
                data["mentorSkillSetDtos"].push(item.toJSON());
            }
        }
        return data;
    };
    return MentorDto;
}());
export { MentorDto };
var MentorUserInfo = /** @class */ (function () {
    function MentorUserInfo(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MentorUserInfo.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            this.lockoutEnd = _data["lockoutEnd"] ? new Date(_data["lockoutEnd"].toString()) : undefined;
            this.twoFactorEnabled = _data["twoFactorEnabled"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.phoneNumber = _data["phoneNumber"];
            this.securityStamp = _data["securityStamp"];
            this.passwordHash = _data["passwordHash"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.normalizedEmail = _data["normalizedEmail"];
            this.email = _data["email"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.userName = _data["userName"];
        }
    };
    MentorUserInfo.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MentorUserInfo();
        result.init(data);
        return result;
    };
    MentorUserInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : undefined;
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["phoneNumber"] = this.phoneNumber;
        data["securityStamp"] = this.securityStamp;
        data["passwordHash"] = this.passwordHash;
        data["emailConfirmed"] = this.emailConfirmed;
        data["normalizedEmail"] = this.normalizedEmail;
        data["email"] = this.email;
        data["normalizedUserName"] = this.normalizedUserName;
        data["userName"] = this.userName;
        return data;
    };
    return MentorUserInfo;
}());
export { MentorUserInfo };
var MentorViewDto = /** @class */ (function () {
    function MentorViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MentorViewDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.fatherName = _data["fatherName"];
            this.fullName = _data["fullName"];
            this.gender = _data["gender"];
            this.religion = _data["religion"];
            this.profession = _data["profession"];
            this.countryName = _data["countryName"];
            this.city = _data["city"];
            this.age = _data["age"];
            this.address = _data["address"];
            this.chargesPerAnswer = _data["chargesPerAnswer"];
            this.appointmentCharges = _data["appointmentCharges"];
            this.availableTimingFrom = _data["availableTimingFrom"];
            this.availableTimingTo = _data["availableTimingTo"];
            this.homeVisit = _data["homeVisit"];
            this.homeVisitCharges = _data["homeVisitCharges"];
            this.averageRating = _data["averageRating"];
            this.userId = _data["userId"];
            this.isProfileCompleted = _data["isProfileCompleted"];
            this.profilePictureID = _data["profilePictureID"];
            this.profilePicture = _data["profilePicture"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined;
            this.isProve = _data["isProve"];
            if (Array.isArray(_data["mentorExperienceDtos"])) {
                this.mentorExperienceDtos = [];
                for (var _i = 0, _a = _data["mentorExperienceDtos"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.mentorExperienceDtos.push(MentorExperienceDto.fromJS(item));
                }
            }
            if (Array.isArray(_data["mentorEducationDtos"])) {
                this.mentorEducationDtos = [];
                for (var _b = 0, _c = _data["mentorEducationDtos"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.mentorEducationDtos.push(MentorEducationDto.fromJS(item));
                }
            }
            if (Array.isArray(_data["mentorSkillSetDtos"])) {
                this.mentorSkillSetDtos = [];
                for (var _d = 0, _e = _data["mentorSkillSetDtos"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.mentorSkillSetDtos.push(MentorSkillSetDto.fromJS(item));
                }
            }
        }
    };
    MentorViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MentorViewDto();
        result.init(data);
        return result;
    };
    MentorViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["fatherName"] = this.fatherName;
        data["fullName"] = this.fullName;
        data["gender"] = this.gender;
        data["religion"] = this.religion;
        data["profession"] = this.profession;
        data["countryName"] = this.countryName;
        data["city"] = this.city;
        data["age"] = this.age;
        data["address"] = this.address;
        data["chargesPerAnswer"] = this.chargesPerAnswer;
        data["appointmentCharges"] = this.appointmentCharges;
        data["availableTimingFrom"] = this.availableTimingFrom;
        data["availableTimingTo"] = this.availableTimingTo;
        data["homeVisit"] = this.homeVisit;
        data["homeVisitCharges"] = this.homeVisitCharges;
        data["averageRating"] = this.averageRating;
        data["userId"] = this.userId;
        data["isProfileCompleted"] = this.isProfileCompleted;
        data["profilePictureID"] = this.profilePictureID;
        data["profilePicture"] = this.profilePicture;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined;
        data["isProve"] = this.isProve;
        if (Array.isArray(this.mentorExperienceDtos)) {
            data["mentorExperienceDtos"] = [];
            for (var _i = 0, _a = this.mentorExperienceDtos; _i < _a.length; _i++) {
                var item = _a[_i];
                data["mentorExperienceDtos"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.mentorEducationDtos)) {
            data["mentorEducationDtos"] = [];
            for (var _b = 0, _c = this.mentorEducationDtos; _b < _c.length; _b++) {
                var item = _c[_b];
                data["mentorEducationDtos"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.mentorSkillSetDtos)) {
            data["mentorSkillSetDtos"] = [];
            for (var _d = 0, _e = this.mentorSkillSetDtos; _d < _e.length; _d++) {
                var item = _e[_d];
                data["mentorSkillSetDtos"].push(item.toJSON());
            }
        }
        return data;
    };
    return MentorViewDto;
}());
export { MentorViewDto };
var MentorCharageDto = /** @class */ (function () {
    function MentorCharageDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MentorCharageDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.appointmentCharges = _data["appointmentCharges"];
        }
    };
    MentorCharageDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MentorCharageDto();
        result.init(data);
        return result;
    };
    MentorCharageDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["appointmentCharges"] = this.appointmentCharges;
        return data;
    };
    return MentorCharageDto;
}());
export { MentorCharageDto };
var LoginResponse = /** @class */ (function () {
    function LoginResponse(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LoginResponse.prototype.init = function (_data) {
        if (_data) {
            this.email = _data["email"];
            this.userName = _data["userName"];
            this.phoneNumber = _data["phoneNumber"];
            this.role = _data["role"];
            this.data = _data["data"];
            this.token = _data["token"];
            this.isSuccess = _data["isSuccess"];
            this.userId = _data["userId"];
            this.autoUserId = _data["autoUserId"];
            this.profilePictureId = _data["profilePictureId"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (var _i = 0, _a = _data["errors"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.errors.push(item);
                }
            }
        }
    };
    LoginResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LoginResponse();
        result.init(data);
        return result;
    };
    LoginResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["userName"] = this.userName;
        data["phoneNumber"] = this.phoneNumber;
        data["role"] = this.role;
        data["data"] = this.data;
        data["token"] = this.token;
        data["isSuccess"] = this.isSuccess;
        data["userId"] = this.userId;
        data["autoUserId"] = this.autoUserId;
        data["profilePictureId"] = this.profilePictureId;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (var _i = 0, _a = this.errors; _i < _a.length; _i++) {
                var item = _a[_i];
                data["errors"].push(item);
            }
        }
        return data;
    };
    return LoginResponse;
}());
export { LoginResponse };
var LoginQuery = /** @class */ (function () {
    function LoginQuery(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LoginQuery.prototype.init = function (_data) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
        }
    };
    LoginQuery.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LoginQuery();
        result.init(data);
        return result;
    };
    LoginQuery.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    };
    return LoginQuery;
}());
export { LoginQuery };
var SignUpResponse = /** @class */ (function () {
    function SignUpResponse(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SignUpResponse.prototype.init = function (_data) {
        if (_data) {
            this.data = _data["data"];
        }
    };
    SignUpResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SignUpResponse();
        result.init(data);
        return result;
    };
    SignUpResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        return data;
    };
    return SignUpResponse;
}());
export { SignUpResponse };
var SignUpCommand = /** @class */ (function () {
    function SignUpCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SignUpCommand.prototype.init = function (_data) {
        if (_data) {
            this.userName = _data["userName"];
            this.roleName = _data["roleName"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.confirmPassword = _data["confirmPassword"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.provider = _data["provider"];
            this.photoUrl = _data["photoUrl"];
        }
    };
    SignUpCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SignUpCommand();
        result.init(data);
        return result;
    };
    SignUpCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["roleName"] = this.roleName;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["password"] = this.password;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["confirmPassword"] = this.confirmPassword;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["provider"] = this.provider;
        data["photoUrl"] = this.photoUrl;
        return data;
    };
    return SignUpCommand;
}());
export { SignUpCommand };
var SignUpWithLoginCommand = /** @class */ (function () {
    function SignUpWithLoginCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SignUpWithLoginCommand.prototype.init = function (_data) {
        if (_data) {
            this.userName = _data["userName"];
            this.roleName = _data["roleName"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.provider = _data["provider"];
            this.photoUrl = _data["photoUrl"];
        }
    };
    SignUpWithLoginCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SignUpWithLoginCommand();
        result.init(data);
        return result;
    };
    SignUpWithLoginCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["roleName"] = this.roleName;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["provider"] = this.provider;
        data["photoUrl"] = this.photoUrl;
        return data;
    };
    return SignUpWithLoginCommand;
}());
export { SignUpWithLoginCommand };
var LogoutQuery = /** @class */ (function () {
    function LogoutQuery(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LogoutQuery.prototype.init = function (_data) {
        if (_data) {
            this.number = _data["number"];
        }
    };
    LogoutQuery.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LogoutQuery();
        result.init(data);
        return result;
    };
    LogoutQuery.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        return data;
    };
    return LogoutQuery;
}());
export { LogoutQuery };
var GetProfilePictureOutput = /** @class */ (function () {
    function GetProfilePictureOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetProfilePictureOutput.prototype.init = function (_data) {
        if (_data) {
            this.profilePicture = _data["profilePicture"];
        }
    };
    GetProfilePictureOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetProfilePictureOutput();
        result.init(data);
        return result;
    };
    GetProfilePictureOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["profilePicture"] = this.profilePicture;
        return data;
    };
    return GetProfilePictureOutput;
}());
export { GetProfilePictureOutput };
var Result = /** @class */ (function () {
    function Result(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Result.prototype.init = function (_data) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (var _i = 0, _a = _data["errors"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.errors.push(item);
                }
            }
        }
    };
    Result.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Result();
        result.init(data);
        return result;
    };
    Result.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (var _i = 0, _a = this.errors; _i < _a.length; _i++) {
                var item = _a[_i];
                data["errors"].push(item);
            }
        }
        return data;
    };
    return Result;
}());
export { Result };
var AppointmentDto = /** @class */ (function () {
    function AppointmentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AppointmentDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.mentorId = _data["mentorId"];
            this.menteeId = _data["menteeId"];
            this.mentorName = _data["mentorName"];
            this.menteeName = _data["menteeName"];
            this.mentorUserId = _data["mentorUserId"];
            this.menteeUserId = _data["menteeUserId"];
            this.profession = _data["profession"];
            this.appointmentDate = _data["appointmentDate"] ? new Date(_data["appointmentDate"].toString()) : undefined;
            this.appointmentTime = _data["appointmentTime"];
            this.timeAgo = _data["timeAgo"];
            this.questionId = _data["questionId"];
            this.status = _data["status"];
            this.charges = _data["charges"];
            this.isPaid = _data["isPaid"];
            this.mentorProfileUrl = _data["mentorProfileUrl"];
            this.menteeProfileUrl = _data["menteeProfileUrl"];
        }
    };
    AppointmentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AppointmentDto();
        result.init(data);
        return result;
    };
    AppointmentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mentorId"] = this.mentorId;
        data["menteeId"] = this.menteeId;
        data["mentorName"] = this.mentorName;
        data["menteeName"] = this.menteeName;
        data["mentorUserId"] = this.mentorUserId;
        data["menteeUserId"] = this.menteeUserId;
        data["profession"] = this.profession;
        data["appointmentDate"] = this.appointmentDate ? this.appointmentDate.toISOString() : undefined;
        data["appointmentTime"] = this.appointmentTime;
        data["timeAgo"] = this.timeAgo;
        data["questionId"] = this.questionId;
        data["status"] = this.status;
        data["charges"] = this.charges;
        data["isPaid"] = this.isPaid;
        data["mentorProfileUrl"] = this.mentorProfileUrl;
        data["menteeProfileUrl"] = this.menteeProfileUrl;
        return data;
    };
    return AppointmentDto;
}());
export { AppointmentDto };
var AdminDashboardDto = /** @class */ (function () {
    function AdminDashboardDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AdminDashboardDto.prototype.init = function (_data) {
        if (_data) {
            this.totalMentor = _data["totalMentor"];
            this.totalMentee = _data["totalMentee"];
            this.totalQuestion = _data["totalQuestion"];
            this.totalOpenQuestion = _data["totalOpenQuestion"];
            this.totalClosedQuestion = _data["totalClosedQuestion"];
            this.totalAppointement = _data["totalAppointement"];
            this.totalCompleteAppointement = _data["totalCompleteAppointement"];
            this.totalUpCoimngAppointement = _data["totalUpCoimngAppointement"];
        }
    };
    AdminDashboardDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdminDashboardDto();
        result.init(data);
        return result;
    };
    AdminDashboardDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalMentor"] = this.totalMentor;
        data["totalMentee"] = this.totalMentee;
        data["totalQuestion"] = this.totalQuestion;
        data["totalOpenQuestion"] = this.totalOpenQuestion;
        data["totalClosedQuestion"] = this.totalClosedQuestion;
        data["totalAppointement"] = this.totalAppointement;
        data["totalCompleteAppointement"] = this.totalCompleteAppointement;
        data["totalUpCoimngAppointement"] = this.totalUpCoimngAppointement;
        return data;
    };
    return AdminDashboardDto;
}());
export { AdminDashboardDto };
var CreatePaymentDto = /** @class */ (function () {
    function CreatePaymentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreatePaymentDto.prototype.init = function (_data) {
        if (_data) {
            this.paymentTo = _data["paymentTo"];
            this.paymentBy = _data["paymentBy"];
            this.questionId = _data["questionId"];
            this.amount = _data["amount"];
            this.description = _data["description"];
            this.cardNumber = _data["cardNumber"];
            this.cardExpiry = _data["cardExpiry"];
            this.cardCvv = _data["cardCvv"];
            this.paymentType = _data["paymentType"];
            this.subscriptionPaymentGatewayType = _data["subscriptionPaymentGatewayType"];
            this.invoiceNo = _data["invoiceNo"];
            this.mobileNumber = _data["mobileNumber"];
            this.cnic = _data["cnic"];
            this.successUrl = _data["successUrl"];
            this.errorUrl = _data["errorUrl"];
        }
    };
    CreatePaymentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreatePaymentDto();
        result.init(data);
        return result;
    };
    CreatePaymentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["paymentTo"] = this.paymentTo;
        data["paymentBy"] = this.paymentBy;
        data["questionId"] = this.questionId;
        data["amount"] = this.amount;
        data["description"] = this.description;
        data["cardNumber"] = this.cardNumber;
        data["cardExpiry"] = this.cardExpiry;
        data["cardCvv"] = this.cardCvv;
        data["paymentType"] = this.paymentType;
        data["subscriptionPaymentGatewayType"] = this.subscriptionPaymentGatewayType;
        data["invoiceNo"] = this.invoiceNo;
        data["mobileNumber"] = this.mobileNumber;
        data["cnic"] = this.cnic;
        data["successUrl"] = this.successUrl;
        data["errorUrl"] = this.errorUrl;
        return data;
    };
    return CreatePaymentDto;
}());
export { CreatePaymentDto };
export var SubscriptionPaymentGatewayType;
(function (SubscriptionPaymentGatewayType) {
    SubscriptionPaymentGatewayType[SubscriptionPaymentGatewayType["EasyPaisa"] = 1] = "EasyPaisa";
    SubscriptionPaymentGatewayType[SubscriptionPaymentGatewayType["JazzCash"] = 2] = "JazzCash";
    SubscriptionPaymentGatewayType[SubscriptionPaymentGatewayType["HBL"] = 3] = "HBL";
    SubscriptionPaymentGatewayType[SubscriptionPaymentGatewayType["Paypal"] = 4] = "Paypal";
    SubscriptionPaymentGatewayType[SubscriptionPaymentGatewayType["Stripe"] = 5] = "Stripe";
    SubscriptionPaymentGatewayType[SubscriptionPaymentGatewayType["JazzCashMobileAccount"] = 6] = "JazzCashMobileAccount";
})(SubscriptionPaymentGatewayType || (SubscriptionPaymentGatewayType = {}));
var CreateOrEditAppointmentDto = /** @class */ (function () {
    function CreateOrEditAppointmentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditAppointmentDto.prototype.init = function (_data) {
        if (_data) {
            this.mentorId = _data["mentorId"];
            this.menteeId = _data["menteeId"];
            this.appointmentDate = _data["appointmentDate"] ? new Date(_data["appointmentDate"].toString()) : undefined;
            this.appointmentTime = _data["appointmentTime"];
            this.questionId = _data["questionId"];
            this.status = _data["status"];
            this.charges = _data["charges"];
        }
    };
    CreateOrEditAppointmentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditAppointmentDto();
        result.init(data);
        return result;
    };
    CreateOrEditAppointmentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["mentorId"] = this.mentorId;
        data["menteeId"] = this.menteeId;
        data["appointmentDate"] = this.appointmentDate ? this.appointmentDate.toISOString() : undefined;
        data["appointmentTime"] = this.appointmentTime;
        data["questionId"] = this.questionId;
        data["status"] = this.status;
        data["charges"] = this.charges;
        return data;
    };
    return CreateOrEditAppointmentDto;
}());
export { CreateOrEditAppointmentDto };
var AppointmentForViewDto = /** @class */ (function () {
    function AppointmentForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AppointmentForViewDto.prototype.init = function (_data) {
        if (_data) {
            this.questionForViewDto = _data["questionForViewDto"] ? QuestionForViewDto.fromJS(_data["questionForViewDto"]) : undefined;
            this.appointmentDate = _data["appointmentDate"];
            this.appointmentTime = _data["appointmentTime"];
            this.status = _data["status"];
            this.charges = _data["charges"];
            this.isPaid = _data["isPaid"];
            this.rejectedNote = _data["rejectedNote"];
            this.questionId = _data["questionId"];
        }
    };
    AppointmentForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AppointmentForViewDto();
        result.init(data);
        return result;
    };
    AppointmentForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["questionForViewDto"] = this.questionForViewDto ? this.questionForViewDto.toJSON() : undefined;
        data["appointmentDate"] = this.appointmentDate;
        data["appointmentTime"] = this.appointmentTime;
        data["status"] = this.status;
        data["charges"] = this.charges;
        data["isPaid"] = this.isPaid;
        data["rejectedNote"] = this.rejectedNote;
        data["questionId"] = this.questionId;
        return data;
    };
    return AppointmentForViewDto;
}());
export { AppointmentForViewDto };
var QuestionForViewDto = /** @class */ (function () {
    function QuestionForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    QuestionForViewDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.mentorId = _data["mentorId"];
            this.menteeId = _data["menteeId"];
            this.mentorName = _data["mentorName"];
            this.menteeName = _data["menteeName"];
            this.mentorUserId = _data["mentorUserId"];
            this.menteeUserId = _data["menteeUserId"];
            this.departmentId = _data["departmentId"];
            this.categoryId = _data["categoryId"];
            this.subCategoryId = _data["subCategoryId"];
            this.profession = _data["profession"];
            this.questionDetail = _data["questionDetail"];
            this.questionDate = _data["questionDate"] ? new Date(_data["questionDate"].toString()) : undefined;
            this.questionTime = _data["questionTime"] ? new Date(_data["questionTime"].toString()) : undefined;
            this.timeAgo = _data["timeAgo"];
            this.audioFileId = _data["audioFileId"];
            this.audioFileDescription = _data["audioFileDescription"];
            this.status = _data["status"];
            this.state = _data["state"];
            this.answersCount = _data["answersCount"];
            this.questionAmount = _data["questionAmount"];
            this.averageRating = _data["averageRating"];
            this.questionRating = _data["questionRating"];
            this.charges = _data["charges"];
            this.isPaid = _data["isPaid"];
            if (Array.isArray(_data["questionResponces"])) {
                this.questionResponces = [];
                for (var _i = 0, _a = _data["questionResponces"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.questionResponces.push(QuestionResponceForViewDto.fromJS(item));
                }
            }
            if (Array.isArray(_data["questionDocuments"])) {
                this.questionDocuments = [];
                for (var _b = 0, _c = _data["questionDocuments"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.questionDocuments.push(CreateOrEditQuestionDocumentDto.fromJS(item));
                }
            }
        }
    };
    QuestionForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new QuestionForViewDto();
        result.init(data);
        return result;
    };
    QuestionForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mentorId"] = this.mentorId;
        data["menteeId"] = this.menteeId;
        data["mentorName"] = this.mentorName;
        data["menteeName"] = this.menteeName;
        data["mentorUserId"] = this.mentorUserId;
        data["menteeUserId"] = this.menteeUserId;
        data["departmentId"] = this.departmentId;
        data["categoryId"] = this.categoryId;
        data["subCategoryId"] = this.subCategoryId;
        data["profession"] = this.profession;
        data["questionDetail"] = this.questionDetail;
        data["questionDate"] = this.questionDate ? this.questionDate.toISOString() : undefined;
        data["questionTime"] = this.questionTime ? this.questionTime.toISOString() : undefined;
        data["timeAgo"] = this.timeAgo;
        data["audioFileId"] = this.audioFileId;
        data["audioFileDescription"] = this.audioFileDescription;
        data["status"] = this.status;
        data["state"] = this.state;
        data["answersCount"] = this.answersCount;
        data["questionAmount"] = this.questionAmount;
        data["averageRating"] = this.averageRating;
        data["questionRating"] = this.questionRating;
        data["charges"] = this.charges;
        data["isPaid"] = this.isPaid;
        if (Array.isArray(this.questionResponces)) {
            data["questionResponces"] = [];
            for (var _i = 0, _a = this.questionResponces; _i < _a.length; _i++) {
                var item = _a[_i];
                data["questionResponces"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.questionDocuments)) {
            data["questionDocuments"] = [];
            for (var _b = 0, _c = this.questionDocuments; _b < _c.length; _b++) {
                var item = _c[_b];
                data["questionDocuments"].push(item.toJSON());
            }
        }
        return data;
    };
    return QuestionForViewDto;
}());
export { QuestionForViewDto };
var QuestionResponceForViewDto = /** @class */ (function () {
    function QuestionResponceForViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    QuestionResponceForViewDto.prototype.init = function (_data) {
        if (_data) {
            this.sequenceNo = _data["sequenceNo"];
            this.message = _data["message"];
            this.messageDate = _data["messageDate"] ? new Date(_data["messageDate"].toString()) : undefined;
            this.messageTime = _data["messageTime"] ? new Date(_data["messageTime"].toString()) : undefined;
            this.timeAgo = _data["timeAgo"];
            this.userId = _data["userId"];
            this.audioFileId = _data["audioFileId"];
            this.audioFileDescription = _data["audioFileDescription"];
            this.status = _data["status"];
            this.profilePicture = _data["profilePicture"];
            this.state = _data["state"];
        }
    };
    QuestionResponceForViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new QuestionResponceForViewDto();
        result.init(data);
        return result;
    };
    QuestionResponceForViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sequenceNo"] = this.sequenceNo;
        data["message"] = this.message;
        data["messageDate"] = this.messageDate ? this.messageDate.toISOString() : undefined;
        data["messageTime"] = this.messageTime ? this.messageTime.toISOString() : undefined;
        data["timeAgo"] = this.timeAgo;
        data["userId"] = this.userId;
        data["audioFileId"] = this.audioFileId;
        data["audioFileDescription"] = this.audioFileDescription;
        data["status"] = this.status;
        data["profilePicture"] = this.profilePicture;
        data["state"] = this.state;
        return data;
    };
    return QuestionResponceForViewDto;
}());
export { QuestionResponceForViewDto };
var CreateOrEditQuestionDocumentDto = /** @class */ (function () {
    function CreateOrEditQuestionDocumentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditQuestionDocumentDto.prototype.init = function (_data) {
        if (_data) {
            this.documentid = _data["documentid"];
            this.documentDescription = _data["documentDescription"];
        }
    };
    CreateOrEditQuestionDocumentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditQuestionDocumentDto();
        result.init(data);
        return result;
    };
    CreateOrEditQuestionDocumentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["documentid"] = this.documentid;
        data["documentDescription"] = this.documentDescription;
        return data;
    };
    return CreateOrEditQuestionDocumentDto;
}());
export { CreateOrEditQuestionDocumentDto };
var CategoryDto = /** @class */ (function () {
    function CategoryDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CategoryDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.departmentName = _data["departmentName"];
        }
    };
    CategoryDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CategoryDto();
        result.init(data);
        return result;
    };
    CategoryDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["departmentName"] = this.departmentName;
        return data;
    };
    return CategoryDto;
}());
export { CategoryDto };
var CatgoryDtOForEdit = /** @class */ (function () {
    function CatgoryDtOForEdit(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CatgoryDtOForEdit.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.departmentId = _data["departmentId"];
        }
    };
    CatgoryDtOForEdit.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CatgoryDtOForEdit();
        result.init(data);
        return result;
    };
    CatgoryDtOForEdit.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["departmentId"] = this.departmentId;
        return data;
    };
    return CatgoryDtOForEdit;
}());
export { CatgoryDtOForEdit };
var SubCategoryForViewDtocs = /** @class */ (function () {
    function SubCategoryForViewDtocs(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SubCategoryForViewDtocs.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.categoryId = _data["categoryId"];
            this.categoryName = _data["categoryName"];
        }
    };
    SubCategoryForViewDtocs.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SubCategoryForViewDtocs();
        result.init(data);
        return result;
    };
    SubCategoryForViewDtocs.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["categoryId"] = this.categoryId;
        data["categoryName"] = this.categoryName;
        return data;
    };
    return SubCategoryForViewDtocs;
}());
export { SubCategoryForViewDtocs };
var CreateOrUpdateSubCategoryDto = /** @class */ (function () {
    function CreateOrUpdateSubCategoryDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrUpdateSubCategoryDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.categoryId = _data["categoryId"];
        }
    };
    CreateOrUpdateSubCategoryDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrUpdateSubCategoryDto();
        result.init(data);
        return result;
    };
    CreateOrUpdateSubCategoryDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["categoryId"] = this.categoryId;
        return data;
    };
    return CreateOrUpdateSubCategoryDto;
}());
export { CreateOrUpdateSubCategoryDto };
var SubCategoryForEditDto = /** @class */ (function () {
    function SubCategoryForEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SubCategoryForEditDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.categoryId = _data["categoryId"];
            this.departmentID = _data["departmentID"];
        }
    };
    SubCategoryForEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SubCategoryForEditDto();
        result.init(data);
        return result;
    };
    SubCategoryForEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["categoryId"] = this.categoryId;
        data["departmentID"] = this.departmentID;
        return data;
    };
    return SubCategoryForEditDto;
}());
export { SubCategoryForEditDto };
var DashboardViewDto = /** @class */ (function () {
    function DashboardViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DashboardViewDto.prototype.init = function (_data) {
        if (_data) {
            this.totalQuestions = _data["totalQuestions"];
            this.todayQuestions = _data["todayQuestions"];
            this.completedQuestions = _data["completedQuestions"];
            this.totalAppointments = _data["totalAppointments"];
            this.todayAppointments = _data["todayAppointments"];
            this.pendingQuestions = _data["pendingQuestions"];
            this.pendingAppointments = _data["pendingAppointments"];
            this.upcomingAppointments = _data["upcomingAppointments"];
        }
    };
    DashboardViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DashboardViewDto();
        result.init(data);
        return result;
    };
    DashboardViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalQuestions"] = this.totalQuestions;
        data["todayQuestions"] = this.todayQuestions;
        data["completedQuestions"] = this.completedQuestions;
        data["totalAppointments"] = this.totalAppointments;
        data["todayAppointments"] = this.todayAppointments;
        data["pendingQuestions"] = this.pendingQuestions;
        data["pendingAppointments"] = this.pendingAppointments;
        data["upcomingAppointments"] = this.upcomingAppointments;
        return data;
    };
    return DashboardViewDto;
}());
export { DashboardViewDto };
var CreateOrEditDepartment = /** @class */ (function () {
    function CreateOrEditDepartment(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditDepartment.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    };
    CreateOrEditDepartment.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditDepartment();
        result.init(data);
        return result;
    };
    CreateOrEditDepartment.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    };
    return CreateOrEditDepartment;
}());
export { CreateOrEditDepartment };
var InvoiceDto = /** @class */ (function () {
    function InvoiceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    InvoiceDto.prototype.init = function (_data) {
        if (_data) {
            this.invoiceNo = _data["invoiceNo"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined;
            this.from = _data["from"];
            this.fromAddressLine1 = _data["fromAddressLine1"];
            this.fromAddressLine2 = _data["fromAddressLine2"];
            this.to = _data["to"];
            this.toAddressLine1 = _data["toAddressLine1"];
            this.toAddressLine2 = _data["toAddressLine2"];
            this.paymentMethod = _data["paymentMethod"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.charges = _data["charges"];
            this.subTotal = _data["subTotal"];
            this.totalAmount = _data["totalAmount"];
            this.paymentNote = _data["paymentNote"];
        }
    };
    InvoiceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new InvoiceDto();
        result.init(data);
        return result;
    };
    InvoiceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["invoiceNo"] = this.invoiceNo;
        data["created"] = this.created ? this.created.toISOString() : undefined;
        data["from"] = this.from;
        data["fromAddressLine1"] = this.fromAddressLine1;
        data["fromAddressLine2"] = this.fromAddressLine2;
        data["to"] = this.to;
        data["toAddressLine1"] = this.toAddressLine1;
        data["toAddressLine2"] = this.toAddressLine2;
        data["paymentMethod"] = this.paymentMethod;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["charges"] = this.charges;
        data["subTotal"] = this.subTotal;
        data["totalAmount"] = this.totalAmount;
        data["paymentNote"] = this.paymentNote;
        return data;
    };
    return InvoiceDto;
}());
export { InvoiceDto };
var PaymentGatewayModel = /** @class */ (function () {
    function PaymentGatewayModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaymentGatewayModel.prototype.init = function (_data) {
        if (_data) {
            this.gatewayType = _data["gatewayType"];
            this.supportsRecurringPayments = _data["supportsRecurringPayments"];
        }
    };
    PaymentGatewayModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaymentGatewayModel();
        result.init(data);
        return result;
    };
    PaymentGatewayModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["gatewayType"] = this.gatewayType;
        data["supportsRecurringPayments"] = this.supportsRecurringPayments;
        return data;
    };
    return PaymentGatewayModel;
}());
export { PaymentGatewayModel };
var CreateQuestionCommand = /** @class */ (function () {
    function CreateQuestionCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateQuestionCommand.prototype.init = function (_data) {
        if (_data) {
            this.createOrEditQuestionDto = _data["createOrEditQuestionDto"] ? CreateOrEditQuestionDto.fromJS(_data["createOrEditQuestionDto"]) : undefined;
        }
    };
    CreateQuestionCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateQuestionCommand();
        result.init(data);
        return result;
    };
    CreateQuestionCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["createOrEditQuestionDto"] = this.createOrEditQuestionDto ? this.createOrEditQuestionDto.toJSON() : undefined;
        return data;
    };
    return CreateQuestionCommand;
}());
export { CreateQuestionCommand };
var CreateOrEditQuestionDto = /** @class */ (function () {
    function CreateOrEditQuestionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditQuestionDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.mentorId = _data["mentorId"];
            this.menteeId = _data["menteeId"];
            this.departmentId = _data["departmentId"];
            this.categoryId = _data["categoryId"];
            this.subCategoryId = _data["subCategoryId"];
            this.questionDetail = _data["questionDetail"];
            this.questionType = _data["questionType"];
            this.questionDate = _data["questionDate"] ? new Date(_data["questionDate"].toString()) : undefined;
            this.audioFileId = _data["audioFileId"];
            this.audioFileDescription = _data["audioFileDescription"];
            this.status = _data["status"];
            if (Array.isArray(_data["questionDocuments"])) {
                this.questionDocuments = [];
                for (var _i = 0, _a = _data["questionDocuments"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.questionDocuments.push(CreateOrEditQuestionDocumentDto.fromJS(item));
                }
            }
        }
    };
    CreateOrEditQuestionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditQuestionDto();
        result.init(data);
        return result;
    };
    CreateOrEditQuestionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mentorId"] = this.mentorId;
        data["menteeId"] = this.menteeId;
        data["departmentId"] = this.departmentId;
        data["categoryId"] = this.categoryId;
        data["subCategoryId"] = this.subCategoryId;
        data["questionDetail"] = this.questionDetail;
        data["questionType"] = this.questionType;
        data["questionDate"] = this.questionDate ? this.questionDate.toISOString() : undefined;
        data["audioFileId"] = this.audioFileId;
        data["audioFileDescription"] = this.audioFileDescription;
        data["status"] = this.status;
        if (Array.isArray(this.questionDocuments)) {
            data["questionDocuments"] = [];
            for (var _i = 0, _a = this.questionDocuments; _i < _a.length; _i++) {
                var item = _a[_i];
                data["questionDocuments"].push(item.toJSON());
            }
        }
        return data;
    };
    return CreateOrEditQuestionDto;
}());
export { CreateOrEditQuestionDto };
var UpdateQuestionCommand = /** @class */ (function () {
    function UpdateQuestionCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateQuestionCommand.prototype.init = function (_data) {
        if (_data) {
            this.createOrEditQuestionDto = _data["createOrEditQuestionDto"] ? CreateOrEditQuestionDto.fromJS(_data["createOrEditQuestionDto"]) : undefined;
        }
    };
    UpdateQuestionCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateQuestionCommand();
        result.init(data);
        return result;
    };
    UpdateQuestionCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["createOrEditQuestionDto"] = this.createOrEditQuestionDto ? this.createOrEditQuestionDto.toJSON() : undefined;
        return data;
    };
    return UpdateQuestionCommand;
}());
export { UpdateQuestionCommand };
var QuestionDto = /** @class */ (function () {
    function QuestionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    QuestionDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.mentorId = _data["mentorId"];
            this.mentor = _data["mentor"] ? MentorDto.fromJS(_data["mentor"]) : undefined;
        }
    };
    QuestionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new QuestionDto();
        result.init(data);
        return result;
    };
    QuestionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mentorId"] = this.mentorId;
        data["mentor"] = this.mentor ? this.mentor.toJSON() : undefined;
        return data;
    };
    return QuestionDto;
}());
export { QuestionDto };
var SelectMentorQuestionCommand = /** @class */ (function () {
    function SelectMentorQuestionCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SelectMentorQuestionCommand.prototype.init = function (_data) {
        if (_data) {
            this.question = _data["question"] ? QuestionDto.fromJS(_data["question"]) : undefined;
        }
    };
    SelectMentorQuestionCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SelectMentorQuestionCommand();
        result.init(data);
        return result;
    };
    SelectMentorQuestionCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["question"] = this.question ? this.question.toJSON() : undefined;
        return data;
    };
    return SelectMentorQuestionCommand;
}());
export { SelectMentorQuestionCommand };
var CreateQuestionResponceCommand = /** @class */ (function () {
    function CreateQuestionResponceCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateQuestionResponceCommand.prototype.init = function (_data) {
        if (_data) {
            this.createOrEditQuestionResponceDto = _data["createOrEditQuestionResponceDto"] ? CreateOrEditQuestionResponceDto.fromJS(_data["createOrEditQuestionResponceDto"]) : undefined;
        }
    };
    CreateQuestionResponceCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateQuestionResponceCommand();
        result.init(data);
        return result;
    };
    CreateQuestionResponceCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["createOrEditQuestionResponceDto"] = this.createOrEditQuestionResponceDto ? this.createOrEditQuestionResponceDto.toJSON() : undefined;
        return data;
    };
    return CreateQuestionResponceCommand;
}());
export { CreateQuestionResponceCommand };
var CreateOrEditQuestionResponceDto = /** @class */ (function () {
    function CreateOrEditQuestionResponceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrEditQuestionResponceDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.questionId = _data["questionId"];
            this.message = _data["message"];
            this.messageDate = _data["messageDate"] ? new Date(_data["messageDate"].toString()) : undefined;
            this.messageTime = _data["messageTime"] ? new Date(_data["messageTime"].toString()) : undefined;
            this.userId = _data["userId"];
            this.audioFileId = _data["audioFileId"];
            this.audioFileDescription = _data["audioFileDescription"];
            this.status = _data["status"];
        }
    };
    CreateOrEditQuestionResponceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrEditQuestionResponceDto();
        result.init(data);
        return result;
    };
    CreateOrEditQuestionResponceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["questionId"] = this.questionId;
        data["message"] = this.message;
        data["messageDate"] = this.messageDate ? this.messageDate.toISOString() : undefined;
        data["messageTime"] = this.messageTime ? this.messageTime.toISOString() : undefined;
        data["userId"] = this.userId;
        data["audioFileId"] = this.audioFileId;
        data["audioFileDescription"] = this.audioFileDescription;
        data["status"] = this.status;
        return data;
    };
    return CreateOrEditQuestionResponceDto;
}());
export { CreateOrEditQuestionResponceDto };
var QuestionViewDto = /** @class */ (function () {
    function QuestionViewDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    QuestionViewDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.mentorId = _data["mentorId"];
            this.menteeId = _data["menteeId"];
            this.mentorName = _data["mentorName"];
            this.menteeName = _data["menteeName"];
            this.mentorUserId = _data["mentorUserId"];
            this.menteeUserId = _data["menteeUserId"];
            this.departmentId = _data["departmentId"];
            this.categoryId = _data["categoryId"];
            this.subCategoryId = _data["subCategoryId"];
            this.profession = _data["profession"];
            this.questionDetail = _data["questionDetail"];
            this.questionDate = _data["questionDate"] ? new Date(_data["questionDate"].toString()) : undefined;
            this.questionTime = _data["questionTime"] ? new Date(_data["questionTime"].toString()) : undefined;
            this.timeAgo = _data["timeAgo"];
            this.audioFileId = _data["audioFileId"];
            this.audioFileDescription = _data["audioFileDescription"];
            this.status = _data["status"];
            this.state = _data["state"];
            this.answersCount = _data["answersCount"];
            this.questionAmount = _data["questionAmount"];
            this.averageRating = _data["averageRating"];
            this.questionRating = _data["questionRating"];
            this.mentorProfileDate = _data["mentorProfileDate"];
            this.menteeProfileDate = _data["menteeProfileDate"];
        }
    };
    QuestionViewDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new QuestionViewDto();
        result.init(data);
        return result;
    };
    QuestionViewDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mentorId"] = this.mentorId;
        data["menteeId"] = this.menteeId;
        data["mentorName"] = this.mentorName;
        data["menteeName"] = this.menteeName;
        data["mentorUserId"] = this.mentorUserId;
        data["menteeUserId"] = this.menteeUserId;
        data["departmentId"] = this.departmentId;
        data["categoryId"] = this.categoryId;
        data["subCategoryId"] = this.subCategoryId;
        data["profession"] = this.profession;
        data["questionDetail"] = this.questionDetail;
        data["questionDate"] = this.questionDate ? this.questionDate.toISOString() : undefined;
        data["questionTime"] = this.questionTime ? this.questionTime.toISOString() : undefined;
        data["timeAgo"] = this.timeAgo;
        data["audioFileId"] = this.audioFileId;
        data["audioFileDescription"] = this.audioFileDescription;
        data["status"] = this.status;
        data["state"] = this.state;
        data["answersCount"] = this.answersCount;
        data["questionAmount"] = this.questionAmount;
        data["averageRating"] = this.averageRating;
        data["questionRating"] = this.questionRating;
        data["mentorProfileDate"] = this.mentorProfileDate;
        data["menteeProfileDate"] = this.menteeProfileDate;
        return data;
    };
    return QuestionViewDto;
}());
export { QuestionViewDto };
var CreateTodoItemCommand = /** @class */ (function () {
    function CreateTodoItemCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateTodoItemCommand.prototype.init = function (_data) {
        if (_data) {
            this.listId = _data["listId"];
            this.title = _data["title"];
        }
    };
    CreateTodoItemCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateTodoItemCommand();
        result.init(data);
        return result;
    };
    CreateTodoItemCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["listId"] = this.listId;
        data["title"] = this.title;
        return data;
    };
    return CreateTodoItemCommand;
}());
export { CreateTodoItemCommand };
var UpdateTodoItemCommand = /** @class */ (function () {
    function UpdateTodoItemCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateTodoItemCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.done = _data["done"];
        }
    };
    UpdateTodoItemCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateTodoItemCommand();
        result.init(data);
        return result;
    };
    UpdateTodoItemCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["done"] = this.done;
        return data;
    };
    return UpdateTodoItemCommand;
}());
export { UpdateTodoItemCommand };
var UpdateTodoItemDetailCommand = /** @class */ (function () {
    function UpdateTodoItemDetailCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateTodoItemDetailCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.listId = _data["listId"];
            this.priority = _data["priority"];
            this.note = _data["note"];
        }
    };
    UpdateTodoItemDetailCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateTodoItemDetailCommand();
        result.init(data);
        return result;
    };
    UpdateTodoItemDetailCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["listId"] = this.listId;
        data["priority"] = this.priority;
        data["note"] = this.note;
        return data;
    };
    return UpdateTodoItemDetailCommand;
}());
export { UpdateTodoItemDetailCommand };
export var PriorityLevel;
(function (PriorityLevel) {
    PriorityLevel[PriorityLevel["None"] = 0] = "None";
    PriorityLevel[PriorityLevel["Low"] = 1] = "Low";
    PriorityLevel[PriorityLevel["Medium"] = 2] = "Medium";
    PriorityLevel[PriorityLevel["High"] = 3] = "High";
})(PriorityLevel || (PriorityLevel = {}));
var TodosVm = /** @class */ (function () {
    function TodosVm(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TodosVm.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["priorityLevels"])) {
                this.priorityLevels = [];
                for (var _i = 0, _a = _data["priorityLevels"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.priorityLevels.push(PriorityLevelDto.fromJS(item));
                }
            }
            if (Array.isArray(_data["lists"])) {
                this.lists = [];
                for (var _b = 0, _c = _data["lists"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.lists.push(TodoListDto.fromJS(item));
                }
            }
        }
    };
    TodosVm.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TodosVm();
        result.init(data);
        return result;
    };
    TodosVm.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.priorityLevels)) {
            data["priorityLevels"] = [];
            for (var _i = 0, _a = this.priorityLevels; _i < _a.length; _i++) {
                var item = _a[_i];
                data["priorityLevels"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.lists)) {
            data["lists"] = [];
            for (var _b = 0, _c = this.lists; _b < _c.length; _b++) {
                var item = _c[_b];
                data["lists"].push(item.toJSON());
            }
        }
        return data;
    };
    return TodosVm;
}());
export { TodosVm };
var PriorityLevelDto = /** @class */ (function () {
    function PriorityLevelDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PriorityLevelDto.prototype.init = function (_data) {
        if (_data) {
            this.value = _data["value"];
            this.name = _data["name"];
        }
    };
    PriorityLevelDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PriorityLevelDto();
        result.init(data);
        return result;
    };
    PriorityLevelDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["name"] = this.name;
        return data;
    };
    return PriorityLevelDto;
}());
export { PriorityLevelDto };
var TodoListDto = /** @class */ (function () {
    function TodoListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TodoListDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(TodoItemDto.fromJS(item));
                }
            }
        }
    };
    TodoListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TodoListDto();
        result.init(data);
        return result;
    };
    TodoListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return TodoListDto;
}());
export { TodoListDto };
var TodoItemDto = /** @class */ (function () {
    function TodoItemDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TodoItemDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.listId = _data["listId"];
            this.title = _data["title"];
            this.done = _data["done"];
            this.priority = _data["priority"];
            this.note = _data["note"];
        }
    };
    TodoItemDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TodoItemDto();
        result.init(data);
        return result;
    };
    TodoItemDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["listId"] = this.listId;
        data["title"] = this.title;
        data["done"] = this.done;
        data["priority"] = this.priority;
        data["note"] = this.note;
        return data;
    };
    return TodoItemDto;
}());
export { TodoItemDto };
var CreateTodoListCommand = /** @class */ (function () {
    function CreateTodoListCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateTodoListCommand.prototype.init = function (_data) {
        if (_data) {
            this.title = _data["title"];
        }
    };
    CreateTodoListCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateTodoListCommand();
        result.init(data);
        return result;
    };
    CreateTodoListCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        return data;
    };
    return CreateTodoListCommand;
}());
export { CreateTodoListCommand };
var UpdateTodoListCommand = /** @class */ (function () {
    function UpdateTodoListCommand(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateTodoListCommand.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
        }
    };
    UpdateTodoListCommand.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateTodoListCommand();
        result.init(data);
        return result;
    };
    UpdateTodoListCommand.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        return data;
    };
    return UpdateTodoListCommand;
}());
export { UpdateTodoListCommand };
var WeatherForecast = /** @class */ (function () {
    function WeatherForecast(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    WeatherForecast.prototype.init = function (_data) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined;
            this.temperatureC = _data["temperatureC"];
            this.temperatureF = _data["temperatureF"];
            this.summary = _data["summary"];
        }
    };
    WeatherForecast.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new WeatherForecast();
        result.init(data);
        return result;
    };
    WeatherForecast.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined;
        data["temperatureC"] = this.temperatureC;
        data["temperatureF"] = this.temperatureF;
        data["summary"] = this.summary;
        return data;
    };
    return WeatherForecast;
}());
export { WeatherForecast };
var SwaggerException = /** @class */ (function (_super) {
    __extends(SwaggerException, _super);
    function SwaggerException(message, status, response, headers, result) {
        var _this = _super.call(this) || this;
        _this.isSwaggerException = true;
        _this.message = message;
        _this.status = status;
        _this.response = response;
        _this.headers = headers;
        _this.result = result;
        return _this;
    }
    SwaggerException.isSwaggerException = function (obj) {
        return obj.isSwaggerException === true;
    };
    return SwaggerException;
}(Error));
export { SwaggerException };
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}
function blobToText(blob) {
    return new Observable(function (observer) {
        if (!blob) {
            observer.next("");
            observer.complete();
        }
        else {
            var reader = new FileReader();
            reader.onload = function (event) {
                observer.next(event.target.result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
